module.exports = __webpack_public_path__ + "static/media/id-verifing.2357173c.png";